Ext.define('SA.view.TableTrackIds', {
    statics: {
        create({rowIds, colIds}) {
            return new SA.view.TableTrackIds({rowIds, colIds});
        }
    },

    constructor({rowIds, colIds}) {
        this.rowIds = rowIds;
        this.colIds = colIds;
    },

    getColIds() {
        return structuredClone(this.colIds);
    },

    getRowIds() {
        return structuredClone(this.rowIds);
    },

    moveColIdAfter(moveColId, afterColId) {
        var rowIds = this.getRowIds(),
            colIds = this.getColIds();

        colIds.splice(colIds.indexOf(moveColId), 1); 
        colIds.splice((colIds.indexOf(afterColId) + 1), 0, moveColId); 

        return SA.view.TableTrackIds.create({rowIds, colIds});
    },

    moveColIdBefore(moveColId, beforeColId) {
        var rowIds = this.getRowIds(),
            colIds = this.getColIds();

        colIds.splice(colIds.indexOf(moveColId), 1); 
        colIds.splice(colIds.indexOf(beforeColId), 0, moveColId); 

        return SA.view.TableTrackIds.create({rowIds, colIds});
    }
});